import { PhoneNumber } from '@/lib/phone/phoneNumber';
import type { ShareLinkTargetDto } from '../api/identityShareApi';

export function filterShareLinkTargets(
  targets: readonly ShareLinkTargetDto[],
  searchText: string,
): ShareLinkTargetDto[] {
  if (searchText.trim() === '') {
    return [...targets];
  }

  const needle = searchText.trim().toLowerCase();
  return targets.filter(
    (target) =>
      (target.displayName?.toLowerCase().includes(needle) ?? false) ||
      (target.userName?.toLowerCase().includes(needle) ?? false) ||
      (target.phoneNumber?.toLowerCase().includes(needle) ?? false),
  );
}

export function normalizePhone(phone: string | null | undefined): string {
  if (phone == null || phone.trim() === '') {
    return '';
  }
  return phone.replace(/\s/g, '');
}

export function extractPhoneCandidate(text: string | null | undefined): string | null {
  if (text == null || text.trim() === '') {
    return null;
  }
  const filtered = [...text].filter((char) => char === '+' || /\d/.test(char)).join('');
  return filtered.length === 0 ? null : filtered;
}

export type NewUserValidationErrors = {
  phoneNumber: string | null;
  displayName: string | null;
};

export function validateNewUserPhoneNumber(phoneNumber: string | null): string[] {
  if (phoneNumber == null || phoneNumber.trim() === '') {
    return ['ShareIncidentDialog_PhoneNumber_Required'];
  }
  if (PhoneNumber.tryInitialize(phoneNumber) === null) {
    return ['ShareIncidentDialog_PhoneNumber_Invalid'];
  }
  return [];
}

export function validateNewUserDisplayName(displayName: string | null): string[] {
  return displayName == null || displayName.trim() === ''
    ? ['ShareIncidentDialog_DisplayName_Required']
    : [];
}

export function validateNewUser(phoneNumber: string | null, displayName: string | null): NewUserValidationErrors {
  return {
    phoneNumber: validateNewUserPhoneNumber(phoneNumber)[0] ?? null,
    displayName: validateNewUserDisplayName(displayName)[0] ?? null,
  };
}

export function tryExtractApiErrorMessage(responseBody: string): string | null {
  try {
    const errors: unknown = JSON.parse(responseBody);
    if (!Array.isArray(errors)) {
      return null;
    }
    return (
      (errors.find(
        (error): error is string => typeof error === 'string' && error.trim() !== '',
      ) as string | undefined) ?? null
    );
  } catch {
    return null;
  }
}

export function insertTargetSorted(
  targets: readonly ShareLinkTargetDto[],
  created: ShareLinkTargetDto,
): ShareLinkTargetDto[] {
  return [...targets, created].sort((a, b) => {
    const left = (a.displayName ?? '').toLowerCase();
    const right = (b.displayName ?? '').toLowerCase();
    return left < right ? -1 : left > right ? 1 : 0;
  });
}
